// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2AGWP","bigColWidth":"Table_bigColWidth__1ZMEX","biggerColWidth":"Table_biggerColWidth__EIID8","row":"Table_row__12JOs","col":"Table_col__1jKAK"};